import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { useTranslation } from 'react-i18next';
import propertyHouseImage from '@public/assets/property_house_IWT.gif';
const GlobalLoader = () => {
    const { t } = useTranslation();
    return (_jsx(Box, { justifyContent: "center", display: "flex", children: _jsxs(Box, { display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", height: "100vh", alignSelf: "center", children: [_jsx("img", { src: propertyHouseImage, alt: "Listing property icon" }), _jsx(Box, { as: "h4", textAlign: "center", children: t('Global_loading.Loading...') }), _jsx(Box, { typography: "typography.body.16.regular", textAlign: "center", children: t('Global_loading.In_just_a_bit_you’ll_start_creating_your_listing.') })] }) }));
};
export default GlobalLoader;
